import React from 'react';
import {cloneDeep} from "lodash";
import {IDownloadManualListItem} from "../interfaces/interfaces";
import DownloadManualItem from "./download-manual-item";

const getItemKey = (manualItem:IDownloadManualListItem,index:number) => {
    return `${ manualItem.documentName }-${ index }-${ manualItem.manualPDF }-${ manualItem.categoryName }`
};

const DownloadManualsList = (props:any) => {
    console.log(props);
    const category = props.category;
    const items = cloneDeep(props.downloadManualsList[category]);

    return (
       <>
           <p className="waves-h4">{category}</p>
           <ul className="waves-ul column-count-1 md:column-count-2 lg:column-count-3">
               {
                   items.map((manualItem:IDownloadManualListItem,index:number) => {
                       return (
                           <DownloadManualItem key={getItemKey(manualItem,index)} manualPDF={manualItem.manualPDF} documentName={manualItem.documentName} categoryName={manualItem.categoryName}/>
                       )
                   })
               }
           </ul>
       </>
    )
}

export default DownloadManualsList;